




































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { masterModule } from '@/store/modules/entities/master.module';
import { Competency } from '@/models/competency/competency';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { SchoolClass } from '@/models/school-class/school-class';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GEnum } from '@/constants/enum.defination';
import { Student } from '@/models/student/student';
import GExamCreateExamineeStudentTable from '../ExamineeSetting/GExamCreateExamineeStudentTable.vue';
import { GPageBase } from '@/mixins';
import GExamCreateConfirmViewItemCell from '@/views/GExamCreate/ConfirmView/GExamCreateConfirmViewItemCell.vue';
import GExamCreateConfirmViewValueCell from '@/views/GExamCreate/ConfirmView/GExamCreateConfirmViewValueCell.vue';
import GExamCreateConfirmViewCompetency from '@/views/GExamCreate/ConfirmView/GExamCreateConfirmViewCompetency.vue';
import { Trend } from '@/models/trend/trend';
import { EvalSettingTitleLang } from '@/models/evalSetting/eval-setting-title-lang';
import { EvalSettingMail } from '@/models/evalSetting/eval-setting-mail';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { Teacher } from '@/models/teacher/teacher';
import { EnvUtils } from '@/utils/env.utils';
import GVTag from '@/components/GVTag.vue';

@Component({
  name: 'GExamCreateConfirmView',
  components: {
    GExamCreateConfirmViewCompetency,
    GExamCreateConfirmViewValueCell,
    GExamCreateConfirmViewItemCell,
    GExamCreateExamineeStudentTable,
    GVTag,
  },
  computed: {},
  methods: {},
})
export default class GExamCreateViewSetting extends Mixins(GPageBase) {
  examineeSchoolClassColumns: any[] = []; // 受検対象者(クラス別)設定テーブルのカラム情報
  isEntryLoading: boolean = false; // 生徒個別データローディングフラグ
  lazy: boolean = false;
  viewExamineeStudents: Student[] = []; // 表示用受検者生徒一覧(すでに割り当てられた生徒＋新規に追加した生徒も)
  viewExamineeSchoolClasses: SchoolClass[] = []; // 表示用受検クラス一覧(すでに割り当てられたクラス＋新規に追加した生徒)

  mounted() {
    //確認画面到達フラグON
    examCreateModule.setVisitConfirmView(true);
    this.setExamineeSchoolClassColumns();

    console.log(this.evalSettingDetail)

    if (!this.evalSettingModeDetail) {
      if (examCreateModule.assignedExamineeStudents.length > 0) {
        // 受検者設定で追加した場合(作成時または更新時)
        this.viewExamineeStudents = examCreateModule.plusExamineeStudents.concat(this.evalSettingDetail.students);
      } else {
        // 受検者設定で追加しなかった場合(更新時のみ)
        this.viewExamineeStudents = this.evalSettingDetail.students;
      }

      //新規作成＆コピー時：選択したクラスを反映する
      //編集時：すでに登録されていたクラスを除き、新たに選択したクラスを反映する
      this.evalSettingDetail.schoolClasses = schoolClassModule.schoolClassesIncludeSelected.filter((schoolClass: SchoolClass) => {
        if (this.selectedSchoolClassIDs.includes(schoolClass.schoolClassID)) {
          return !schoolClass.selected;
        }
      });

      this.viewExamineeSchoolClasses = schoolClassModule.schoolClassesIncludeSelected.filter((schoolClass: SchoolClass) => {
        return this.selectedSchoolClassIDs.includes(schoolClass.schoolClassID) && !schoolClass.selected;
      });

      const alreadyAssignedSchoolClasses = schoolClassModule.schoolClassesIncludeSelected.filter((schoolClass: SchoolClass) => {
        return this.selectedSchoolClassIDs.includes(schoolClass.schoolClassID) && schoolClass.selected;
      });

      this.viewExamineeSchoolClasses = this.viewExamineeSchoolClasses.concat(...alreadyAssignedSchoolClasses);

      if (!this.evalSettingModeDetail) {
        //ラジオボタンのパラメータをbooleanに変換
        this.evalSettingDetail.isEvaluatorVisible = this.convertRadioToBoolean(this.evalSettingDetail.isEvaluatorVisibleRadio);
        this.evalSettingDetail.isProgressNotification = this.convertRadioToBoolean(this.evalSettingDetail.isProgressNotificationRadio);
        this.evalSettingDetail.freeWordSkillRequired = this.convertRadioToBoolean(this.evalSettingDetail.freeWordSkillRequiredRadio);
        this.evalSettingDetail.isPostingReportEnabled = this.convertRadioToBoolean(this.evalSettingDetail.isPostingReportEnabledRadio);
        this.evalSettingDetail.trendRequired = this.convertRadioToBoolean(this.evalSettingDetail.trendRequiredRadio);
        this.evalSettingDetail.mailSetting.sendRegularly = this.convertRadioToBoolean(this.evalSettingDetail.mailSetting.sendRegularlyView);
        //傾向チェックのみ受検の場合、受検画面にはフィードバックレポート表示しない
        if (this.evalSettingDetail.trendRequiredOnly) {
          this.evalSettingDetail.isPostingReportEnabledRadio = GEnum.RadioLabel.False;
          this.evalSettingDetail.isPostingReportEnabled = false;
        }
      }
      //受検内容コピーの場合、受検画面にはフィードバックレポート表示しない
      if (this.evalSettingModeCopy) {
        this.evalSettingDetail.isPostingReportEnabledRadio = GEnum.RadioLabel.False;
        this.evalSettingDetail.isPostingReportEnabled = false;
      }
    } else {
      this.viewExamineeSchoolClasses = this.evalSettingDetail.schoolClasses;
      this.viewExamineeStudents = this.evalSettingDetail.students;
    }
    this.lazy = true;
  }

  setExamineeSchoolClassColumns() {
    this.examineeSchoolClassColumns = [
      {
        title: this.$t('GRADE').toString(),
        key: 'grade',
        width: '100',
        align: 'center',
        render: (h: any, params: any) => {
          const schoolClass: SchoolClass = params.row;
          return h('span', schoolClass.grade + this.$t('YEAR').toString());
        },
      },
      {
        title: this.$t('SCHOOL_CLASS').toString(),
        key: 'schoolClassName',
        width: '705',
        align: 'center',
      },
    ];
  }

  rowClassNameForSchoolClass(row: SchoolClass): string {
    if (row.selected) {
      return 'disable-row';
    }
  }

  setCurrentStep(value: number) {
    examCreateModule.setCurrentStep(value);
  }

  get plusExamineeCountWithSuffix(): string {
    if (this.isAssignStudent) {
      return `${examCreateModule.plusExamineeStudents.length}`;
    } else {
      return `${this.evalSettingDetail.schoolClasses.length}` + this.$t('SCHOOL_CLASS').toString();
    }
  }

  get examineeCountWithSuffix(): string {
    if (this.isAssignStudent) {
      return `${this.viewExamineeStudents.length}`;
    } else {
      return `${this.viewExamineeSchoolClasses.length}` + this.$t('SCHOOL_CLASS').toString();
    }
  }

  get visitQuestionSettingView(): boolean {
    return examCreateModule.visitQuestionSettingView;
  }

  get visitExamineeSettingView(): boolean {
    return examCreateModule.visitExamineeSettingView;
  }

  get isAssignStudent(): boolean {
    return examCreateModule.isAssignStudent;
  }

  get isAssignSchoolClass(): boolean {
    return examCreateModule.isAssignSchoolClass;
  }

  get examineeSelectionTypeString(): string {
    return examCreateModule.examineeSelectionTypeString;
  }

  get examineeSelectionType(): GEnum.ExamineeSelectionType {
    return examCreateModule.examineeSelectionType;
  }

  get selectedSchoolClassIDs(): number[] {
    return examCreateModule.selectedSchoolClassIDs;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get questionTypeTitle(): string {
    if (masterModule.allQuestionTypes.length === 0 || this.evalSettingDetail.questionSettingType < 0) {
      return '';
    }
    return masterModule.questionTypeByAll(this.evalSettingDetail.questionSettingType).title;
  }

  get competencyCognitive(): Competency[] {
    return masterModule.competencyCognitive.map((competency: Competency) => {
      competency.selected = examCreateModule.selectionCognitive.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get competencySelf(): Competency[] {
    return masterModule.competencySelf.map((competency: Competency) => {
      competency.selected = examCreateModule.selectionSelf.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get competencyGift(): Competency[] {
    return masterModule.competencyGift.map((competency: Competency) => {
      competency.selected = examCreateModule.selectionGift.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get competencyCommunity(): Competency[] {
    return masterModule.competencyCommunity.map((competency: Competency) => {
      competency.selected = examCreateModule.selectionCommunity.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get evalSettingModeEdit(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Edit;
  }

  get evalSettingModeCreate(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Create;
  }

  get evalSettingModeCopy(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Copy;
  }

  get evalSettingModeDetail(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Detail;
  }

  get showIsEvaluatorVisible(): string {
    if (this.evalSettingDetail.isEvaluatorVisible) {
      return this.$t('VALID').toString();
    }
    return this.$t('INVALID').toString();
  }

  get couseAlias(): EvalSettingTitleLang[] {
    return this.evalSettingDetail.titleLangs
  }

  get showEvaluationRequestPermissionCategory(): string {
    switch (this.evalSettingDetail.evaluationRequestPermissionCategory) {
      case GEnum.EvaluationRequestPermissionCategory.PermitOnlySameCourseStudents:
        return this.$t('EVALUATION_REQUEST_PERMISSION_CATEGORY_1').toString();
      case GEnum.EvaluationRequestPermissionCategory.PermitOnlySameSchoolStudents:
        return this.$t('EVALUATION_REQUEST_PERMISSION_CATEGORY_2').toString();
      case GEnum.EvaluationRequestPermissionCategory.PermitContainGuest:
        return this.$t('EVALUATION_REQUEST_PERMISSION_CATEGORY_3').toString();
      case GEnum.EvaluationRequestPermissionCategory.NotPermit:
        return this.$t('EVALUATION_REQUEST_PERMISSION_CATEGORY_4').toString();
      default:
        return '';
    }
  }

  get showFreeWordSkillRequired(): string {
    if (this.evalSettingDetail.freeWordSkillRequired) {
      return this.$t('YES').toString();
    }
    return this.$t('NOT_SELECT').toString();
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get showTrendRequired(): string {
    if (this.evalSettingDetail.trendRequired) {
      return this.$t('YES').toString();
    }
    return this.$t('NOT_SELECT').toString();
  }

  get showTrends(): string {
    if (!this.evalSettingDetail.trendRequired) return this.$t('NOT_SELECT').toString();
    if (!this.evalSettingDetail.trendIDs.length) return this.$t('NOT_SELECT').toString();
    return masterModule.trends
      .filter((trend: Trend) => this.evalSettingDetail.trendIDs.includes(trend.trendID))
      .map((trend: Trend) => trend.title)
      .join(',');
  }

  // get showIsProgressNotification(): string {
  //   if (this.evalSettingDetail.isProgressNotification) {
  //     return '毎日送信する';
  //   }
  //   return '通知しない';
  // }

  get showCompetencySettingType(): string {
    switch (this.evalSettingDetail.competencySettingType) {
      case GEnum.CompetencySettingType.Full:
        return this.$t('FULL_SETTING').toString();
      case GEnum.CompetencySettingType.Recommend:
        return this.$t('RECOMMENDED_SETTING').toString();
      case GEnum.CompetencySettingType.Mini:
        return this.$t('MINI').toString();
      case GEnum.CompetencySettingType.Customize:
        return this.$t('DETAIL_SETTING').toString();
    }
  }

  get showExams(): string {
    const exams: string[] = [];

    if (this.evalSettingDetail.iatRequired) {
      exams.push(this.$t('IAT').toString());
    }
    if (this.evalSettingDetail.giftRequired) {
      exams.push(this.$t('GIFT_SCORE').toString());
    }
    if (this.evalSettingDetail.selfEvalRequired) {
      exams.push(this.$t('SELF_EVAL').toString());
    }
    if (this.evalSettingDetail.trendRequired) {
      exams.push(this.$t('TREND_CHECK').toString());
    }
    return exams.join(',');
  }

  get changeExaminee(): boolean {
    return this.viewExamineeSchoolClasses.length > 0 || this.viewExamineeStudents.length > 0;
  }

  get mailSetting(): EvalSettingMail {
    return this.evalSettingDetail.mailSetting;
  }

  get mailSettingDates(): Date[] {
    return this.mailSetting.dates;
  }

  // 相互評価有りの受検で、既に評価設定・評価依頼が存在している場合はボタンを非活性に
  get giftEvalCourseNotUpdate(): boolean {
    // 相互評価"無し"受検の更新時、評価設定が存在、または、評価依頼が存在する場合は true => ボタンが非活性
    return (!this.evalSettingDetail.giftRequired) && (this.evalSettingDetail.hasEvalRequest || this.evalSettingDetail.hasEvalRequestApproval);
  }

  get teachers() {
    let tempTeachers: Teacher[] = [];
    tempTeachers = teacherModule.validTeachers;
    return tempTeachers.filter((teacher: Teacher) => {
      if (this.mailSetting.ids.includes(teacher.teacherID)) {
        return true;
      }
    });
  }

  // feature flag AIGROW2-518 teacher mail
  get isFeatureFlagTeacherMail(): boolean {
    return EnvUtils.getBoolean("VUE_APP_FEATURE_FLAG_GIFT_COURSE_MAIL")
  }

  handleGotoExamEdit() {
    this.$router.push(`/pages/exam/create?mode=${GEnum.EvalSettingMode.Edit}&evalSettingID=${this.evalSettingDetail.evalSettingID}`);
  }

  handleEntryEvalSetting() {
    this.lazyAction(() => {
      this.isEntryLoading = true;
      this.evalSettingDetail.competencyIDs = examCreateModule.selectedCompetencyIDs;
      examCreateModule.setIsAutoPageTransition(true);
      examCreateModule.setExamineeStudentIDs(examCreateModule.plusExamineeStudents.map((student: Student) => student.studentID));
      examCreateModule.setExamineeSchoolClassIDs(this.viewExamineeSchoolClasses.map((schoolClass: SchoolClass) => schoolClass.schoolClassID));
      examCreateModule.entryEvalSetting(this.evalSettingDetail).then((newEvalSetting: EvalSetting) => {
        this.isEntryLoading = false;
        this.showNotice(GEnum.MessageType.Success, this.$t('CREATE_EVAL_COURSE').toString(), this.$t('MESSAGE_CREATE_EVAL_COURSE', {value: this.evalSettingDetail.title}).toString(), 10);

        setTimeout(() => {
          this.$router.replace(`/pages/exam/list`);
        }, 2000);
      });
    });
  }

  handleUpdateEvalSetting() {
    this.lazyAction(() => {
      this.isEntryLoading = true;
      this.evalSettingDetail.competencyIDs = examCreateModule.selectedCompetencyIDs;
      examCreateModule.setIsAutoPageTransition(true);
      examCreateModule.setExamineeStudentIDs(examCreateModule.plusExamineeStudents.map((student: Student) => student.studentID));
      examCreateModule.setExamineeSchoolClassIDs(
        this.viewExamineeSchoolClasses
          .filter((schoolClass: SchoolClass) => {
            return !schoolClass.selected;
          })
          .map((schoolClass: SchoolClass) => schoolClass.schoolClassID)
      );
      examCreateModule.updateEvalSetting(this.evalSettingDetail).then((newEvalSetting: EvalSetting) => {
        this.isEntryLoading = false;
        this.showNotice(GEnum.MessageType.Success, this.$t('UPDATE_EVAL_COURSE').toString(), this.$t('MESSAGE_UPDATE_EVAL_COURSE', {value: this.evalSettingDetail.title}).toString(), 10);
        setTimeout(() => {
          this.$router.replace(`/pages/exam/list`);
        }, 2000);
      });
    });
  }
}
